/*import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaArrowLeft, FaInfoCircle, FaCross } from 'react-icons/fa';
import axios from '../api/axios';

export default function SepulturaDetail() {
  const { id } = useParams();
  const [sepultura, setSepultura] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSepultura = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`/sepulturasc/${id}`);        
        setSepultura(response.data);
      } catch (err) {
        setError('Error al cargar los detalles de la sepultura. Por favor, intente de nuevo.');
        console.error('Error fetching sepultura details:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSepultura();
  }, [id]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded" role="alert">
          <p className="font-bold">Error</p>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!sepultura) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded" role="alert">
          <p className="font-bold">Advertencia</p>
          <p>No se encontró la sepultura</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <Link to="/home/sepulturas" className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-6 transition-colors duration-200">
        <FaArrowLeft className="mr-2" /> Volver a la lista de sepulturas
      </Link>
      <div className="bg-white shadow-2xl rounded-lg overflow-hidden">
        <div className="bg-gradient-to-r from-gray-700 to-gray-900 p-6 text-white">
          <h2 className="text-3xl font-bold flex items-center">
            <FaCross className="mr-4 text-4xl" />
            Sepulturaxxx #{sepultura.id}
          </h2>
        </div>
        <div className="p-6 space-y-6">
          <div className="bg-gray-50 p-6 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg">
            <h3 className="text-xl font-semibold mb-4 text-gray-800 flex items-center">
              <FaInfoCircle className="mr-2 text-yellow-600" /> identificador
            </h3>
            <p className="text-gray-700">{sepultura.terceroId || 'No hay descripción disponible'}</p>
          </div>

        </div>
      </div>
    </div>
  );
}
*/
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaArrowLeft, FaInfoCircle, FaCross, FaTape, FaSass, FaAddressCard } from 'react-icons/fa';
import axios from '../api/axios';

export default function SepulturaDetail() {
  const { id } = useParams();
  const [sepultura, setSepultura] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSepultura = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`/sepulturasc/${id}`);
        setSepultura(response.data);
      } catch (err) {
        setError('Error al cargar los detalles de la sepultura. Por favor, intente de nuevo.');
        console.error('Error fetching sepultura details:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSepultura();
  }, [id]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded" role="alert">
          <p className="font-bold">Error</p>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!sepultura) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded" role="alert">
          <p className="font-bold">Advertencia</p>
          <p>No se encontró la sepultura</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <Link to="/home/sepulturas" className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-6 transition-colors duration-200">
        <FaArrowLeft className="mr-2" /> Volver a la lista de sepulturas
      </Link>
      <div className="bg-white shadow-2xl rounded-lg overflow-hidden">
        <div className="bg-gradient-to-r from-gray-700 to-gray-900 p-6 text-white">
          <h2 className="text-3xl font-bold flex items-center">
            <FaAddressCard className="mr-4 text-4xl" />
            Sepultura #{sepultura.id}
          </h2>
        </div>
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <DetailCard title="ID" content={sepultura.id} />
          <DetailCard title="Tipo ID" content={sepultura.tipoId} />
          <DetailCard title="Lugar ID" content={sepultura.lugareId} />
          <DetailCard title="Serie" content={sepultura.serie} />
          <DetailCard title="Número" content={sepultura.numero} />
          <DetailCard title="Fecha Documento" content={sepultura.fechaDocumento} />
          <DetailCard title="Tercero ID" content={sepultura.terceroId} />
          <DetailCard title="Fecha Concesión" content={sepultura.fechaConcesion} />
          <DetailCard title="Clausurado" content={sepultura.clausurado ? 'Sí' : 'No'} />
          <DetailCard title="Ocupado" content={sepultura.ocupado ? 'Sí' : 'No'} />
          <DetailCard title="Importe Tasa" content={sepultura.importeTasa} />
          <DetailCard title="Cuenta Bancaria" content={sepultura.cuentaBancaria} />
          <DetailCard title="Bonificado" content={sepultura.bonificado ? 'Sí' : 'No'} />
          <DetailCard title="Observaciones" content={sepultura.observaciones} />
          <DetailCard title="Contacto" content={sepultura.contacto} />
          <DetailCard title="Domicilio" content={sepultura.domicilio} />
          <DetailCard title="Teléfono" content={sepultura.telefono} />
          <DetailCard title="GPS" content={sepultura.gps} />
          <DetailCard title="Mapeo" content={sepultura.mapeo} />
          <DetailCard title="Traslado ID" content={sepultura.trasladoId} />
          <DetailCard title="Creado En" content={sepultura.createdAt} />
          <DetailCard title="Actualizado En" content={sepultura.updatedAt} />
        </div>
      </div>
    </div>
  );
}

function DetailCard({ title, content }) {
  return (
    <div className="bg-gray-50 p-4 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg">
      <h3 className="text-sm font-semibold mb-2 text-gray-800 flex items-center">
        <FaInfoCircle className="mr-2 text-yellow-600" /> {title}
      </h3>
      <p className="text-gray-700 text-sm">{content || 'No disponible'}</p>
    </div>
  );
}
